import React from "react";
import PanelFrame from "../../ui/PanelFrame";
import siteConfig from "../../../config/siteConfig";

const DiscordWidget = () => {
  return (
    <PanelFrame title="Discord">
      <div className="mu-discord" style={{ textAlign: "center" }}>
        <p style={{ color: "var(--mu-text-muted)", marginTop: 0 }}>
          Join the official Discord server
        </p>
        <iframe
          title="Discord Widget"
          src={siteConfig.social.discordWidget}
          width="100%"
          height="320"
          allowTransparency="true"
          frameBorder="0"
          sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
          style={{ borderRadius: 4, maxWidth: "100%", width: "100%" }}
        />
      </div>
    </PanelFrame>
  );
};

export default DiscordWidget;
